import React from 'react'

import Profile from './User'
import { SettingsOrganizationsInformations } from 'screens/SettingsOrganizationsInformations'
import Users from 'screens/SettingsOrganizationsMembers'
import Invitations from './Organization/Invitations'
import Authentication from './Organization/Authentication'
import Channels from './Organization/Channels'
import Integrations from './Organization/Integrations'
import Billing from './Organization/Billing'
import Flags from './Organization/Flags'
import UserGroups from './Organization/UserGroups'
import Analytics from './Organization/Analytics'
import * as tabTypes from './tabTypes'
import { SettingsLayoutWrapper } from './Layout'

const Content = ({ tab, options }) => {
  let child = null
  let width
  let className

  switch (tab) {
    case tabTypes.PROFILE.id:
      child = <Profile />
      break
    case tabTypes.INFORMATIONS.id:
      child = <SettingsOrganizationsInformations />
      break
    case tabTypes.USERS.id:
      width = '100%'
      className = 'height-full'
      child = <Users />
      break
    case tabTypes.USER_GROUPS.id:
      child = <UserGroups />
      break
    case tabTypes.INVITATIONS.id:
      child = (
        <Invitations defaultEmails={options.email ? [options.email] : ['']} />
      )

      break
    case tabTypes.AUTHENTICATION.id:
      child = <Authentication />
      break
    case tabTypes.CHANNELS.id:
      child = <Channels />
      break
    case tabTypes.INTEGRATIONS.id:
      child = <Integrations subsection={options} />
      break
    case tabTypes.BILLING.id:
      child = <Billing subsection={options} />
      break
    case tabTypes.FLAGS.id:
      child = <Flags />
      break
    case tabTypes.ANALYTICS.id:
      child = <Analytics />
      break
    default:
      return null
  }

  return (
    <SettingsLayoutWrapper className={className} width={width}>
      {child}
    </SettingsLayoutWrapper>
  )
}

export default Content
